__webpack_require__.p = "/reactjs_portfolio_avijit/";